"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC, Rowdies} from 'next/font/google';
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Divider, Pagination} from "@mantine/core";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {indexPublicationQuery} from "@/service";
import ResourceCard from "@/app/(index)/science-and-technology-policy-research/resource-card";
import {IPublicationQueryOutputForm} from "@/form/publication";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800', '900'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const rowdies = Rowdies({
    weight: ['300', '400', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});


const Page = ({ params }: { params: { team_id: string, id: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    const [outputResult, setOutputResult] = useState<IPublicationQueryOutputForm | null>(null);

    useEffect(() => {
        query();
    }, [lang]);

    const query = (page: number = 1) => {
        indexPublicationQuery(page, lang).then(result => {
            setOutputResult(result);
        })
    }

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="科技政策研究" name_e="Policy Research"/>
                    )
                }

                <div className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        { lang == "tw" ? "科技政策研究" : "Policy Research"}
                    </div>

                    <div className="text-[20px] leading-[40px]">
                        {
                            lang == "tw" ? (
                                <>
                                    科政中心自2005 年改制以來，持續支援國科會草擬我國科技白皮書，亦負責協助辦理全科會等政策幕僚的工作，同時也致力完備政策知識平台、產業資料庫及人才與指標的連結，以政策研究及創新服務雙軌並進，全方位協助政府科技部會加速推動國家科技發展與研發成果創新，提升國家總體競爭力。
                                </>
                            ) : (
                                <>
                                    Since its reorganization in 2005, STPI has continuously supported the National Science and Technology Council (NSTC) in drafting Taiwan’s S&T White Paper and coordinating the National Science and Technology Conference. Meanwhile, STPI is dedicated to enhancing policy knowledge platforms, industry databases, and the integration of talent and indicators. By advancing both policy research and innovation services, STPI comprehensively assists the government in accelerating national technological development and R&D innovation, thereby enhancing Taiwan’s overall competitiveness.
                                </>
                            )
                        }
                    </div>

                    <Divider color={"#cedbdc"} mt={35} mb={30}/>

                    <div className={"flex flex-col gap-[10px]"}>
                        {
                            outputResult?.obj?.map((item, index) => (
                                <ResourceCard
                                    key={`list-view-${item.pubId}`}
                                    name={item.title} summary={item.summary} link={item.linkUrl} image={item.coverArhId?.arhId!!}/>
                            ))
                        }
                    </div>
                    {
                        (outputResult?.totalPages ?? 0) > 1 && (
                            <div className="mt-10 flex justify-end">
                                <Pagination total={outputResult?.totalPages!!}
                                            value={outputResult?.nowPage}
                                            radius={"xl"}
                                            color="#316d68"
                                            siblings={2}
                                            className={cx(rowdies.className, "font-light")}
                                            onChange={query} mt="sm"/>
                            </div>
                        )
                    }

                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Page
